import { useCallback, useEffect, useState } from 'react';
import { API } from '@service';
import useProjectId from './useProjectId';

export const InsightChartType = {
  OrgChart: 'org',
  GanttChart: 'gantt',
};

const useInsightsChart = (chartType) => {
  const [loading, setLoading] = useState(false);
  const projectId = useProjectId();
  const [data, setData] = useState([]);

  const saveData = async (dataToSave) => {
    setLoading(true);
    try {
      const result = await API.saveCustomzizedWidget(projectId, '', dataToSave);
      if (result.message === 'save chart successfully') {
        dataToSave.data = result.data;
        setData({
          id: result.id,
          ...dataToSave,
        });
      }
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };
  const fetchData = useCallback(async (projectId, chartType) => {
    setLoading(true);
    try {
      const res = await API.getInsightsChart(projectId, chartType);
      const result = res?.[0];
      if (result) {
        if (typeof result.data === 'string') {
          try {
            result.data = JSON.parse(result.data);
          } catch (e) {
            console.log(e);
          }
        }
        setData(result);
      }
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (projectId && chartType) {
      fetchData(projectId, chartType);
    }
  }, [projectId, chartType]);

  return {
    data,
    fetchData,
    saveData,
    loading,
  };
};

export default useInsightsChart;
